import { render } from "./SectionFifteen.vue?vue&type=template&id=480a98cf&scoped=true"
import script from "./SectionFifteen.vue?vue&type=script&lang=js"
export * from "./SectionFifteen.vue?vue&type=script&lang=js"

import "./SectionFifteen.vue?vue&type=style&index=0&id=480a98cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480a98cf"]])

export default __exports__